export const appRegex = {
  numeros: /^\d+$/,
}
